import { instanceConfig, classConfig } from "./config"
import { deepMerge } from "./deep-merge"

export function firstExt(Class) {
  return class extends Class {
    afterFactory(...args) {
      if (super.afterFactory)
        return super.afterFactory(...args)
    }
    afterInit(...args) {
      if (super.afterInit)
        return super.afterInit(...args)
    }
    beforeInit(...args) {
      if (super.beforeInit)
        return super.beforeInit(...args)
    }
    init(...args) {
      if (super.init)
        return super.init(...args)
    }
    static afterFactory(...args) {
      if (super.afterFactory)
        return super.afterFactory(...args)
    }
    static afterFactoryOnce(...args) {
      if (super.afterFactoryOnce)
        return super.afterFactoryOnce(...args)
    }
    static beforeFactory(...args) {
      if (super.beforeFactory)
        return super.beforeFactory(...args)
    }
    static beforeFactoryOnce(...args) {
      if (super.beforeFactoryOnce)
        return super.beforeFactoryOnce(...args)
    }
    static factory(...args) {
      if (super.factory)
        return super.factory(...args)
    }
  }
}

function configure(config, ...args) {
  this._industry = this._industry || config
  args.forEach(arg =>
    this._industry = deepMerge(this._industry, arg)
  )
  return this._industry
}

export function lastExt(Class) {
  return class extends Class {
    industry(...args) {
      return configure.bind(this)(instanceConfig(), ...args)
    }

    static industry(...args) {
      return configure.bind(this)(classConfig(), ...args)
    }
  }
}
